import styled from "styled-components";
import { Chat } from "ui/blocks/chat/Chat";
import { ClassSection } from "./sections/ClassSection";
import { useChat } from "hooks/useChat";
import { useAuth } from "context/AuthContext";
import { ChatList } from "ui/blocks/chat/ChatList";
import { useMediaQuery } from "react-responsive";
import { useEffect, useState } from "react";
import { mediaSizes, pageContainerStyles } from "ui/theme";
import { NoContent } from "ui/base/NoContent/NoContent";
import NoMessagesFound from "ui/icons/not-found-icons/noMessages.svg";
import { getOrCreateConversation } from "services/firestore/getOrCreateConversation";
import { useLocation } from "react-router-dom";
import { LoaderComponent } from "ui/base/loading/LoaderComponent";

export const Messages = () => {
    const location = useLocation();
    const { classDetail } = location.state || {};

    const { userData, userRole } = useAuth();

    // senderId
    const currentUserId = userData?.id;
    const participantId = classDetail?.id?.toString();
    const teacherID = classDetail?.teacher_id || classDetail?.teacher?.id;

    const [selectedMobileChat, setSelectedMobileChat] = useState(null);
    const [activeUserId, setActiveUserId] = useState(teacherID);

    const {
        chatMessages, // messages
        chatList, // messageList
        activeConversation, // conversationSelected
        handleSelectConversation, // onClickMessage
        handleSendMessage,
        isLoading,
        isLoadingChat
    } = useChat(currentUserId, 1, activeUserId);

    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });


    useEffect(() => {
        if (teacherID)
            setActiveUserId(teacherID)
    }, [teacherID])

    const handleSelection = (c) => {
        setActiveUserId(null);
        handleSelectConversation(c);
        setSelectedMobileChat(c);
    }

    if (isLoading)
        return (
            <LoaderComponent
                minHeight="var(--page-height)"
                textColor="#000000"
            />
        )

    return (
        <>
            {chatList?.length ?
                <Container>
                    {isMobile ? (
                        <>
                            {selectedMobileChat != null ? (
                                <>
                                    <Chat
                                        sendMessage={handleSendMessage}
                                        messages={chatMessages}
                                        conversation={selectedMobileChat}
                                        currentUserId={currentUserId}
                                        onGoBack={() => {
                                            if (selectedMobileChat) {
                                                setSelectedMobileChat(null);
                                                return;
                                            }
                                            setMobileOverlayVisibility(false);
                                        }}
                                        isLoading={isLoadingChat}
                                    />
                                </>

                            ) : (
                                <ChatList
                                    chatList={chatList}
                                    onClickMessage={(c) => {
                                        handleSelection(c)
                                    }}

                                    activeConversation={activeConversation}
                                    currentUserId={currentUserId}

                                />
                            )}
                        </>
                    ) : (
                        <>

                            <ChatList
                                chatList={chatList}
                                onClickMessage={(c) => {
                                    handleSelection(c)
                                }}
                                activeConversation={activeConversation}
                                currentUserId={currentUserId}
                            />
                            <Chat
                                messages={chatMessages}
                                sendMessage={handleSendMessage}
                                conversation={activeConversation}
                                currentUserId={currentUserId}
                                isLoading={isLoadingChat}
                            />
                        </>)
                    }
                    <ClassSection
                        classId={activeConversation?.userData?.teacher_user_id}
                    />
                </Container>
                :
                <NoContentContainer>
                    <NoContent
                        title="You don't have any messages"
                        image={NoMessagesFound}
                        size={280}
                    />
                </NoContentContainer>}
        </>
    );
};

const Container = styled.div`
    ${pageContainerStyles}
    font-family: var(--font-secondary);
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    height: var(--page-height);

    @media (width >= ${mediaSizes.md}) {
        grid-template-columns: 0.8fr 1fr;
        gap: 1.5rem;
    }

    @media (width >= ${mediaSizes.lg}) {
        height: var(--page-height);
        grid-template-columns: 1fr 50% 1fr;
    }
`;

const NoContentContainer = styled.div`
height: var(--page-height);

    @media (width >= ${mediaSizes.md}) { 
        gap: 1.5rem;
        padding-inline: 2rem;
    }

    @media (width >= ${mediaSizes.lg}) {
        height: var(--page-height); 
    }
`

